import React, { FC, Suspense, useMemo } from 'react';
import { Conditional } from 'components/pcc-components';
import ContactDealerTooltip from './contact-dealer-tooltip';
import Price from 'components/price';
import { ProductDealerPriceAvailability } from 'services/dealerPriceAvailability/types';
import { CatSkeleton } from 'components/blocks-components';
import { usePartDiagram } from 'hooks/use-part-diagram/parts-diagram-context';
import { LineItem } from 'types/parts-diagram';

export interface PartCardPriceProps {
  currency: string;
  partItem: LineItem;
  modifiedPriceData: ProductDealerPriceAvailability;
  className: string;
  isMobileView?: boolean;
  fromProductPage?: boolean;
}

const PartCardPrice: FC<PartCardPriceProps> = ({
  currency,
  partItem,
  modifiedPriceData,
  className,
  isMobileView = false,
  fromProductPage
}) => {
  const { isCatCorp } = usePartDiagram();
  const {
    ieSystemControlNumber = null,
    priceAndAvailabilityData,
    partNumber
  } = partItem || {};

  const productPrice = useMemo(() => {
    return (
      <Price
        currency={currency}
        price={
          partNumber === modifiedPriceData?.partNumber
            ? modifiedPriceData
            : priceAndAvailabilityData
        }
        showDiscountSection={fromProductPage}
        isMobileView={isMobileView}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priceAndAvailabilityData]);
  return (
    <Conditional
      test={!!ieSystemControlNumber}
      fallback={
        !isCatCorp &&
        (priceAndAvailabilityData?.enableAddToCart ? (
          <Suspense fallback={modifiedPriceData && <CatSkeleton size="lg" />}>
            <div className={className}>{productPrice}</div>
          </Suspense>
        ) : (
          !isMobileView &&
          <ContactDealerTooltip />
        ))
      }
    />
  );
};

export default PartCardPrice;
